import moment from 'moment';

export const checkIsBeetween = (start: Date | string, end: Date | string): boolean => {
    return moment().isBetween(start, end);
};
